import { Locale } from './locales'

export interface ContactInfo {
  orderPhone?: string
  supportPhone?: string
  sizeHelperPhone?: string
  email: string
  url: string
}

export const CONTACT_INFO: Record<Locale, ContactInfo> = {
  [Locale.De]: {
    supportPhone: '089 3803 6998',
    email: 'service.de@madeleine.com',
    url: '/c/service/kontaktformular/',
  },
  [Locale.At]: {
    supportPhone: '055 74 80 330',
    email: 'service.at@madeleine.com',
    url: '/c/service/kontaktformular/',
  },
  [Locale.Ch]: {
    supportPhone: '0848 889 848',
    email: 'service.ch@madeleine.com',
    url: '/c/service/kontaktformular/',
  },
  [Locale.FrCh]: {
    supportPhone: '0848 889 848',
    email: 'service.ch@madeleine.com',
    url: '/c/service/contact/',
  },
  [Locale.Fr]: {
    supportPhone: '0892 688 909',
    email: 'info@goldner.fr',
    url: '/c/service/contact/',
  },
  [Locale.FrBe]: {
    supportPhone: '070 22 30 56',
    email: 'service.be@madeleine.com',
    url: '/c/service/contact/',
  },
  [Locale.Nl]: {
    supportPhone: '030 - 65 92 540',
    email: 'service.nl@madeleine.com',
    url: '/c/service/contact/',
  },
  [Locale.Be]: {
    supportPhone: '070 22 20 21',
    email: 'service.be@madeleine.com',
    url: '/c/service/contact/',
  },
  [Locale.Uk]: {
    supportPhone: '0203 936 5 456',
    email: 'service.uk@madeleine.com',
    url: '/c/service/contact/',
  },
}
